import type { MarketApp as MarketAppType } from '@wix/ambassador-devcenter-market-apps-v1-market-app/types';
import { EAppBadges } from '@wix/app-market-services-types';
import { MarketApp } from './market-app';

export class MarketApps {
  constructor(
    private readonly marketApps: MarketAppType[],
    private readonly showVerified: boolean = true,
  ) {}

  findByAppId(appId: string) {
    const marketApp = new MarketApp(
      this.marketApps.find((app) => app.appId === appId),
    ).toJSON();

    if (this.showVerified) {
      return marketApp;
    }

    return {
      ...marketApp,
      badges: marketApp.badges.filter(
        (badge) => badge.badge !== EAppBadges.VERIFIED_BY_WIX,
      ),
    };
  }
}
